// src/pages/AboutPage.jsx
import React from "react";
import "../styles/About.css";
import "../styles/mobile-About.css";

import Footer from "../components/Footer";
import MobileFooterSheet from "../components/MobileFooterSheet";

import image from "../assets/images/about/Frame (4).png";
import image1 from "../assets/images/about/Frame (5).png";
import image2 from "../assets/images/about/Frame (6).png";
import image3 from "../assets/images/about/Frame (7).png";
import image4 from "../assets/images/about/Frame (8).png";
import image5 from "../assets/images/about/Frame (9).png";
import image6 from "../assets/images/about/Frame (10).png";
import image7 from "../assets/images/about/Frame (11).png";
import image8 from "../assets/images/about/Isolation_Mode.png";
import logo from "../assets/images/logo-login.png";

export default function AboutPage({ setCurrentView }) {
  return (
    <div className="about-page" dir="rtl">
      <div className="clip-bg" aria-hidden="true" />
      <center>
        <img src={logo} className="about-logo" alt="Partech" style={{ position: "relative", zIndex: "999", width: "344px", height: "74px", marginTop: "10px" }} />
      </center>
      <div className="about-wrap">
        {/* Hero */}
        <header className="about-hero">
          <h1 className="about-title">
            <img src={image} width={20} alt="" style={{ marginLeft: "10px" }} /> ايش هي بارتك – احفظها؟
          </h1>
          <p className="about-lead">
            إحنا مو مجرد شركة قطع غيار… إحنا فريق يعشق عالم السيارات والتقنية، وعشنا نفس
            المعاناة اللي يمرون فيها كثير من الناس كل يوم وهم يدورون قطع غيار لسياراتهم. شفنا
            الغلاء، تفاوت الأسعار، والممارسات الغير نزيهة اللي تهدر الوقت، الجهد والفلوس، ومن هنا
            انطلقنا.
          </p>
          <p className="about-lead">
            وظفنا خبرتنا وشغفنا في عالم السيارات وتقنية المعلومات لإيجاد حل جذري.
          </p>
          <p className="about-lead">
            وإحنا اليوم موجودين لنوفر لكم قطع الغيار المستخدمة، الأصلية الوكالة، بأفضل سعر،
            وأنظف حالة، لتوصل لمكانكم بدون أي عناء، وكل هذا من خلال موقعنا الإلكتروني اللي
            يصوّر لكم القطعة وكأنها بين يديكم.
          </p>
          <p className="about-lead">
            قاعدين نشتغل ليل مع نهار لنطور سوق قطع الغيار في المملكة العربية السعودية لمستوى
            عالمي: سوق مرتب، شفاف، يخدم الناس بأفضل جودة، أقل سعر، وبأسرع وقت. والأهم، بخدمة
            عملاء موثوقة وضمانات تريح راسكم.
          </p>
          <p className="about-lead">
            باختصار... بارتك موجودة عشان تسهّل عليك، ونخلي رحلتك مع سيارتك أمتع وأبسط.
          </p>
        </header>

        {/* Sections */}
        <section className="about-card">
          <h1 className="about-title">الشروط والأحكام</h1>
          <h2 className="about-h2">
            <img src={image1} width={20} alt="" /> الاسترجاع والاستبدال
          </h2>
          <ul className="about-list">
            <li className="custom-li">
              لو القطعة ما ناسبتك أو ما كانت مثل الوصف، تقدر ترجّعها أو تبدلها خلال 3–7 أيام حسب
              الموضح في وصف كل قطعة.
            </li>
            <li className="custom-li">أهم شيء تكون القطعة بالحالة اللي استلمتها عليها.</li>
            <li className="custom-li">رسوم الشحن على العميل إلا إذا الغلط من عندنا، وقتها إحنا نتحمل.</li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image8} width={30} alt="" />
            الشحن والتوصيل
          </h2>
          <ul className="about-list">
            <li>نوصل داخل الرياض خلال يوم عمل كحد أقصى.</li>
            <li>نوصل لمختلف مدن المملكة خلال 2–5 أيام عمل على حسب المسافة.</li>
            <li>الطلبات اللي تكلفة شحنها فوق 120 ريال شحنها علينا مجانًا.</li>
            <li>نتعامل مع شركات توصيل مضمونة عشان توصلك قطعك بسرعة وأمان.</li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image2} width={20} alt="" />
            الخصوصية
          </h2>
          <ul className="about-list">
            <li>بياناتك عندنا في أمان 100%، ما نشاركها مع أحد.</li>
            <li>الدفع يتم عن طريق بوابات آمنة ومشفرة 100%.</li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image3} width={20} alt="" />
            الضمان
          </h2>
          <ul className="about-list">
            <li className="custom-li">كل قطعة نفحصها بكل دقة وأمانة قبل ما نوصلها لك.</li>
            <li className="custom-li">
              لو طلع فيها خلل ما ذكرناه، لك الحق تسترجع فلوسك كاملة أو نبدلك القطعة على حسب
              رغبتك.
            </li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image5} width={20} alt="" />
            حقوق الملكية
          </h2>
          <ul className="about-list">
            <li>المحتوى والتصاميم في الموقع مملوكة لشركة بارتك – احفظها.</li>
            <li>لا يُسمح بنسخ أو إعادة استخدام أي محتوى بدون إذن كتابي مسبق.</li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image4} width={20} alt="" />
            الدفع
          </h2>
          <ul className="about-list">
            <li>تقدر تدفع عن طريق: أبل باي، مدى، فيزا، ماستركارد، تمارا.</li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image5} width={20} alt="" />
            الحقوق
          </h2>
          <ul className="about-list">
            <li>جميع الصور، المحتوى، والشعارات في الموقع ملك لشركة بارتك – احفظها.</li>
            <li>يُمنع النسخ أو الاستخدام دون إذن رسمي.</li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image6} width={20} alt="" />
            إخلاء المسؤولية
          </h2>
          <ul className="about-list">
            <li>بارتك غير مسؤولة عن أي ضرر ناتج عن سوء تركيب القطعة.</li>
          </ul>
        </section>

        <section className="about-card">
          <h2 className="about-h2">
            <img src={image7} width={20} alt="" />
            الدعم والتواصل
          </h2>
          <ul className="about-list">
            <li>ودّنا نكون قريبين منك، لذلك وفّرنا لك أكثر من وسيلة:</li>
            <ul style={{ marginTop: "-10px" }}>
              <li style={{ marginTop: "-25px", marginRight: "35px" }}>
                <a
                  href="https://wa.me/966567076324"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  واتساب: 0567076324
                </a>
              </li>

              <li style={{ marginRight: "35px" }}>
                <a
                  href="mailto:example@email.com"
                  style={{ color: "inherit", textDecoration: "none" }}
                >
                  الإيميل: support@partechsa.com
                </a>
              </li>

              <li style={{ marginRight: "35px" }}>
                أوقات التواصل: من 8 ص – إلى 5 م
              </li>
            </ul>


          </ul>
        </section>
      </div>

      {/* Footer */}
      <div className="desktop-only about">
        <Footer setCurrentView={setCurrentView} />
      </div>
      <div className="hero" style={{ position: "relative", bottom: "20px" }}>
        <MobileFooterSheet mode="sticky" />
      </div>
    </div>
  );
}
